.scrollWrapper {
    overflow: hidden;
    border-radius: 12px;
}

.scrollArea {
    background-color: white;
}

.body {
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: break-word;

    & * {
        max-width: 100%;
    }

    & h4 {
        margin: 0;
    }
}
